import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initObservability, setupGlobalErrorHandlers, logger, trackPageView } from './lib/observability';

// Initialize observability before rendering
initObservability({
  appName: 'life-os',
  environment: import.meta.env.MODE as 'development' | 'production',
  minLogLevel: import.meta.env.MODE === 'production' ? 'warn' : 'debug',
  enableConsole: true,
  enablePerformance: true,
});

// Set up global error handlers
setupGlobalErrorHandlers();

// Track initial page view
trackPageView(window.location.pathname);

logger.info('App starting', {
  environment: import.meta.env.MODE,
  userAgent: navigator.userAgent,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        logger.info('Service Worker registered', { scope: registration.scope });
      })
      .catch((error) => {
        logger.error('Service Worker registration failed', error);
      });
  });
}
